import { useLocalStorage } from '@vueuse/core';

export const useAcceptedHubsTerms = () => {
  const acceptedHubsTerms = useLocalStorage<string[]>(
    'accepted-hubs-terms',
    [],
  );

  const acceptHubTerms = (hubId: string) => {
    acceptedHubsTerms.value = [...acceptedHubsTerms.value, hubId];
  };

  const areHubTermsAccepted = (hubId: string) => {
    return acceptedHubsTerms.value.includes(hubId);
  };

  return {
    acceptHubTerms,
    areHubTermsAccepted,
  };
};
